<template>
  <div id="app" class="container">
    <app-auswahl></app-auswahl>
    <router-view></router-view>
  </div>
</template>

<script>
  import Auswahl from './components/Auswahl.vue';

  export default {
    components: {
      appAuswahl: Auswahl
    },
    created () {
      this.$store.dispatch('tryAutoLogin');
    }
  }
</script>

<style>
</style>
